import * as React from "react";
import {
  TableCell,
} from "@mui/material";

function Infoview(props) {
    const { OS, FactName } = props;
    const [rows, setrows] = React.useState([]);
  
    React.useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}/api/generics/${OS}/${FactName}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((resp) => {
          setrows(resp[0]);
        })
        .catch((error) => {
          console.error(error);
        });
    }, []);
  
    return (
      <React.Fragment>
        <TableCell
          colspan="100%"
          style={{
            textAlign: "-webkit-left",
            background: "#94deda61",
          }}
        >
          <div style={{ whiteSpace: "pre-wrap" }}>
            <h5>CIS_Description</h5>
            <p style={{ fontSize: "0.75rem", fontWeight: "500" }}>
              {rows.cis_description}
            </p>{" "}
          </div>
          <div style={{ whiteSpace: "pre-wrap" }}>
            <h5>CIS_Remediation</h5>
            <p style={{ fontSize: "0.75rem", fontWeight: "500" }}>
              {rows.cis_remediation}
            </p>{" "}
          </div>
          <div style={{ whiteSpace: "pre-wrap" }}>
            <h5>CIS_Rationale</h5>
            <p style={{ fontSize: "0.75rem", fontWeight: "500" }}>
              {rows.cis_rationale}
            </p>{" "}
          </div>
          <div style={{ whiteSpace: "pre-wrap" }}>
            <h5>CIS_Impact</h5>
            <p style={{ fontSize: "0.75rem", fontWeight: "500" }}>
              {rows.cis_impact}
            </p>{" "}
          </div>
        </TableCell>
      </React.Fragment>
    );
  }
  
  export default Infoview;
  